<template>
    <p @click="openZendesk" class="ze-contactUs" :style="customStyles">
        {{ $t('CONTACT_US_EMAIL') }}
    </p>
</template>

<script>
import { mapGetters } from 'vuex';
import { CSPageEvents } from '@/helpers/GAHelpers';

export default {
    name: 'EmailUs',
    props: {
        customStyles: {
            type: Object,
        },
    },
    computed: {
        ...mapGetters({
            fullName: 'account/getFullName',
            email: 'account/getEmail',
            isUserLoggedIn: 'auth/isUserLoggedIn',
        }),
        getfullUserName() {
            return this.isUserLoggedIn ? this.fullName : '';
        },
        getUserEmail() {
            return this.isUserLoggedIn ? this.email : '';
        },
    },
    methods: {
        openZendesk() {
            zE('webWidget', 'show');
            zE('webWidget', 'open');
            zE('webWidget', 'prefill', {
                name: {
                    value: this.getfullUserName,
                },
                email: {
                    value: this.getUserEmail,
                },
            });
            CSPageEvents('send-us-an-email');
        },
    },
};
</script>

<style lang="scss">
.ze-contactUs {
    cursor: pointer;
    &:hover {
       text-decoration: underline;
    }
}
#webWidget {
  z-index: 9999999999 !important;
}
</style>
